import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Certifications from "./Certifications";
import FadeIn from "../FadeIn";
import wanderlustfinal from "../../Assets/Projects/wanderlustfinal.png";
import Spotify from "../../Assets/Projects/Spotify.png";
import SupportIQ from "../../Assets/Projects/SupportIQ.png";
import GenResume from "../../Assets/Projects/GenResume.png";

function Projects() {
  return (
    <>
      <Container fluid className="project-section">
        <Container>
          <FadeIn direction="up">
            <h1 className="project-heading">
              My Recent <strong className="purple">Works </strong>
            </h1>
          </FadeIn>
          <FadeIn direction="up" delay={0.1}>
            <p style={{ color: "white" }}>
              Here are a few projects I've worked on recently.
            </p>
          </FadeIn>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <FadeIn direction="left" delay={0.2}>
                <ProjectCard
                  imgPath={wanderlustfinal}
                  isBlog={false}
                  title="Wanderlust"
                  description="A travel accommodation web application that allows users to explore and list unique stays across destinations. Built with a modern full-stack architecture, it includes property listings, search functionality, pricing per night, and a responsive, user-friendly interfacex."
                  ghLink="https://github.com/Yashh0222/wanderlust-project"
                  demoLink="https://wanderlust-project-18.onrender.com/listings"
                />
              </FadeIn>
            </Col>

            <Col md={4} className="project-card">
              <FadeIn direction="right" delay={0.3}>
                <ProjectCard
                  imgPath={Spotify}
                  isBlog={false}
                  title="Spotify (Clone)"
                  description="A frontend-only implementation of a Spotify-inspired music streaming interface, featuring playlist views, navigation panels, and a responsive layout built with modern frontend technologies."
                  ghLink="https://github.com/Yashh0222/Spotify-Clone-"
                />
              </FadeIn>
            </Col>

            <Col md={4} className="project-card">
              <FadeIn direction="left" delay={0.2}>
                <ProjectCard
                  imgPath={SupportIQ}
                  isBlog={false}
                  title="SupportIQ"
                  description="An embeddable, multi-tenant AI support widget powered by agentic RAG: it self-grades retrieval, calls tools via MCP, and hands off to humans when unsure. Built with React, FastAPI, LangGraph, and ChromaDB."
                  ghLink="https://github.com/Yashh0222/SupportIQ"
                  demoLink="https://support-iq-yk.vercel.app/"
                />
              </FadeIn>
            </Col>

            <Col md={4} className="project-card">
              <FadeIn direction="right" delay={0.3}>
                <ProjectCard
                  imgPath={GenResume}
                  isBlog={false}
                  title="GenResume"
                  description="Upload a resume and job description, get a match score, tailored interview questions, skill-gap analysis, a day-wise prep plan, and a tailored resume PDF. Built with React, Express, MongoDB, and Groq structured outputs."
                  ghLink="https://github.com/Yashh0222/Gen-Resume"
                  demoLink="https://gen-resume.vercel.app/"
                />
              </FadeIn>
            </Col>
          </Row>
        </Container>
      </Container>
      <Certifications />
    </>
  );
}

export default Projects;